/**
 * getDeliveryDate — shared delivery date helper
 *
 * Returns a human-readable delivery window like:
 * "Mon, 14 Mar – Thu, 17 Mar"
 *
 * Used on PDP and Cart surfaces to keep messaging consistent.
 */
export function getDeliveryDate(minDays = 5, maxDays = 8, locale = 'en-IN') {
  const today = new Date();
  const addDays = (d, n) => {
    const r = new Date(d);
    r.setDate(r.getDate() + n);
    return r;
  };
  const min = addDays(today, minDays);
  const max = addDays(today, maxDays);
  const fmt = (d) =>
    d.toLocaleDateString(locale, {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
    });
  return `${fmt(min)} – ${fmt(max)}`;
}

